import script from "./ViewEvidenceAttachmentModal.vue?vue&type=script&lang=ts&setup=true"
export * from "./ViewEvidenceAttachmentModal.vue?vue&type=script&lang=ts&setup=true"

import "./ViewEvidenceAttachmentModal.vue?vue&type=style&index=0&id=5e0d3053&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5e0d3053"]])

export default __exports__